export default "{\n    \"generic\": \"Une erreur s'est produite.\"\n}\n"